<template>
  <div class="vscode-container">
    <div class="left-panel">
      <Inbox @chatItemClick="handleChatItemClick"></Inbox>
    </div>
    <div class="right-panel">
      <shadan-chat :chatData="selectedChatData"></shadan-chat>
    </div>
  </div>
</template>

<script>
import Inbox from "./Inbox.vue";
import ShadanChat from "./ShadanChat.vue";

export default {
  name: "VscodeChat",
  components: {
    Inbox,
    ShadanChat,
  },
  data() {
    return {
      selectedChatData: null, // 选中的聊天数据
    };
  },
  methods: {
    // 处理会话列表点击事件
    handleChatItemClick(chatData) {
      console.log('[Vscode] 接收到聊天数据:', chatData);
      this.selectedChatData = chatData;
      
      // 设置UI状态为聊天模式，确保ShadanChat显示聊天界面
      this.$store.commit("changeViewCode", 1);
      
      // 激活对应的聊天会话，传递完整的会话信息包括终端信息
      this.$store.commit("openChat", {
        type: chatData.type,
        targetId: chatData.targetId,
        showName: chatData.showName,
        headImage: chatData.headImage,
        isTerminalChat: chatData.isTerminalChat,
        isTerminalInbox: chatData.isTerminalInbox,
        senderTerminal: chatData.senderTerminal,
        targetTerminal: chatData.targetTerminal,
        receivingTerminal: chatData.receivingTerminal,
      });
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.vscode-container {
  display: flex;
  height: 100vh;
  width: 100%;
  
  .left-panel {
    width: 50%;
    height: 100%;
    border-right: 1px solid #e4e7ed;
    overflow: hidden;
  }
  
  .right-panel {
    width: 50%;
    height: 100%;
    overflow: hidden;
  }
}

@media screen and (max-width: 768px) {
  .vscode-container {
    flex-direction: column;

    .left-panel {
      width: 100%;
      height: 100%;
      border-right: none;
    }

    .right-panel {
      display: none;
    }
  }
}
</style>
